import Swal from 'sweetalert2';

export const loadingBox = (loadingText) => {
  Swal.fire({
    title: loadingText,
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    confirmButtonColor: '#278e8e',
    willOpen: () => {
      Swal.showLoading();
    },
  });
};
